import moment from 'moment';
import Api from '../Api';
import QRCode from 'qrcode';

export function createApp(store) {
    // eslint-disable-next-line no-undef
    let app = PetiteVue.createApp({
        store,
        ticketUUID: null,
        ticket: null,
        isLoadingTicket: false,
        timeLeft: "00:00:00",

        mounted(ticketUUID) {
            this.ticketUUID = ticketUUID;
            this.loadTicket();
        },

        async loadTicket() {
            this.isLoadingTicket = true;
            try {
                this.ticket = await Api.ticket.get(this.ticketUUID);

                if (this.ticket.status == 'waiting_for_deposit') {
                    this.updateTimeToPay();
                    setInterval(() => {
                        this.updateTimeToPay();
                    }, 1000);

                    setInterval(() => {
                        this.updateTicketStatus();
                    }, 15000);

                    setTimeout(() => {
                        // eslint-disable-next-line no-undef
                        let canvas = document.getElementById('qr-canvas');
                        QRCode.toCanvas(canvas, this.ticket.depositAddress, function (error) {
                            if (error) console.error(error)
                        })
                    }, 500);
                    
                }
            } catch (e) {
                console.error('Failed to get ticket', e);
            }
            this.isLoadingTicket = false;

        },

        async updateTicketStatus() {
            try {
                this.ticket = await Api.ticket.get(this.ticketUUID);
            } catch (e) {
                console.error('Failed to get ticket', e);
            }
        },

        updateTimeToPay() {
            let expire = moment(this.ticket.expiringAt);
            let now = moment();
            let diff = expire.diff(now);
            if (diff < 0) {
                this.timeLeft = '00:00:00';
                return;
            }
            let duration = moment.duration(diff);
            let hours = Math.floor(duration.asHours());
            let minutes = duration.minutes();
            let seconds = duration.seconds();
            this.timeLeft = `${hours}:${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
        }
    });
    return app;
}